module.exports = __webpack_public_path__ + "static/media/trash-undo.547812aa.svg";